import { useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { accessToken } from '../../util/auth';


export const PrivateRoute = (props) => {
  const loggedIn = accessToken()

  let navigate = useNavigate();

  useEffect(() => {
    if (!loggedIn) {
      return navigate("/");
    }
  }, [loggedIn, navigate]);

  return props.children
}